<template>
    <div>
        <a
        v-if="this.data.status == 'Invoice Generated' || this.data.status == 'Confirmed'"
       :href="`/comprobante/idPayment/${this.data.idPayment}` | downloadUrl"
        class="btn btn-sm btn-webon-table"
        >
             <img style="width: 15px !important;" :src="'icons/recibo-pago.png' | baseImg" />
        </a>
    </div>
</template>
<script>

export default {
  name: "row-actions",
  props: {
    data: {
      type: Object,
    },
  },
  methods: {
    onCreditClicked() {
      console.log("Open Modal to Credit Card");
    },
  },
};
</script>